import { combineEpics } from 'redux-observable'
import { insightEpic } from 'components/features/beacon/epics/insightEpic'
import { flushEventsEpic } from 'components/features/beacon/epics/flushEventsEpic'

export const beaconEpics = combineEpics(
  insightEpic,
  flushEventsEpic,
)
